import React, {useMemo} from 'react';

import {Dialog, DialogBody, DialogFooter, Button, VF, Row, Col, Card, ModalComponentProps, makeValidate, Yup} from '@mc/ui-v4';

import {Form, FormRenderProps} from 'react-final-form';

type Coordinates = {
    width: number;
    height: number;
};

type Props = ModalComponentProps & {
    title: string;
    initialValues?: Coordinates;
    onSubmit: (data: Coordinates) => void;
};

/** * Modální dialog "Přidání polygonu rozměry" *
 * @param initialValues
 * @param title
 * @param onClose
 * @param onSubmit
 * @param initialValues
 *  @param onSubmit*/

export const sizesSchema = Yup.object().shape({
    width: Yup.number().required('Zadejte šířku objektu').positive('Šířka musí být větší než 0'),
    // .max(100000, 'Šířka musí být menší nebo rovna 10000 metru'),
    height: Yup.number().required('Zadejte výšku objektu').positive('Výška musí být větší než 0'),
    // .max(100000, 'Výška musí být menší nebo rovna 100000 metru'),
});
export const PolyFixedModal: React.FC<Props> = ({title, initialValues, onClose, onSubmit}) => {
    const validate = useMemo(() => makeValidate(sizesSchema), []);

    return (
        <Form<Coordinates>
            initialValues={initialValues}
            validate={async data => {
                return await validate(data);
            }}
            onSubmit={onSubmit}
        >
            {({submitting, handleSubmit}: FormRenderProps<Coordinates>) => {
                return (
                    <Dialog isOpen onClose={onClose} title={title}>
                        <DialogBody>
                            <Card mode={'edit'} className="p-2">
                                <Row>
                                    <Col>
                                        <VF.Number key={'sirka'} disabled={submitting} name={'width'} label={'Šířka (m)'} required={true} decimal />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <VF.Number key={'vyska'} disabled={submitting} name={'height'} label={'Výška (m)'} required={true} decimal />
                                    </Col>
                                </Row>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button danger disabled={submitting} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style="primary" disabled={submitting} onClick={handleSubmit} type={'submit'}>
                                Vytvořit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
